import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  canales: null,
  isLoading: false,
};

const canalSelectorSlice = createSlice({
  name: "business/canales",
  initialState,
  reducers: {
    clearCanales: {
      prepare: () => ({ payload: {} }),
      reducer: () => initialState,
    },
    fetchCanalesInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: (state) => {
        state.canales = null;
        state.isLoading = true;
      },
    },
    fetchCanalesCompleted: {
      prepare: (response) => ({ payload: { response } }),
      reducer: (state, action) => {
        state.canales = action.payload.response.map((item) => ({
          value: item.key,
          label: item.value,
        }));
        state.isLoading = false;
      },
    },
    fetchCanalesFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: (state) => {
        state.canales = null;
        state.isLoading = false;
      },
    },
  },
});

const {
  clearCanales,
  fetchCanalesInited,
  fetchCanalesCompleted,
  fetchCanalesFailed,
} = canalSelectorSlice.actions;

const fetchCanales = (tipoCredito) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(fetchCanalesInited({ tipoCredito }));
      const response = await services.api.getCanales(tipoCredito);
      dispatch(fetchCanalesCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(fetchCanalesFailed(error));
    }
  };
};

export default canalSelectorSlice.reducer;
export {
  clearCanales,
  fetchCanalesInited,
  fetchCanalesCompleted,
  fetchCanalesFailed,
  fetchCanales,
};
